module.exports = __webpack_public_path__ + "static/media/3beeps.b1a1620.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/3beeps.wav
// module id = 127
// module chunks = 1